import * as Models from "../../ts/rlAdmin.models";
import * as Utils from "../../ts/rlAdmin.utils";
import * as Consts from "../../ts/rlAdmin.consts";
import { AdminConfigService } from "../../services/admin-config-service";
import { NotifyService } from "../../services/notify-service";
import { DateLocaleService } from "../../services/date-locale-service";
import { EntityService } from "../../services/entity-service";
import { ease } from "d3";
import { access } from "fs";

export class ManualStatusUpdateController {
	static $inject = ["$scope", "$window", "$location", "$filter", "$q", "adminConfigService", "notifyService", "dateLocaleService", "entityService"];

	bulkModel: Models.MassUpdate;
	charTypeID: number;
	recID: number;
	recRevID: number;
	staID: number;
	jobId: string;
	jobTitle: string;
	progressStatus: string;
	showJobProgressStatus: boolean;
	charTypes: Models.IKeyValuePair<string, string>[];
	charTemplate: Models.IEntityCharTypeTemplate[];
	charStatus: Models.IEntityStatus[];

	constructor(private $scope: ng.IScope, private $window: ng.IWindowService, private $location: ng.ILocationService, private $filter: ng.IFilterService,
		private $q: ng.IQService, private adminConfigService: AdminConfigService, private notifyService: NotifyService,
		private dateLocaleService: DateLocaleService, private entityService: EntityService) {
		this.bulkModel;

		this.charTypes = [];
		this.charTemplate = [];
		this.charStatus = [];
		this.showJobProgressStatus = false;
	}

	Init() {
		var promise1 = this.adminConfigService.GetEntityCharTypes()
			.then((result) => {
				this.charTypes = result;
			});

		this.$q.all([promise1])
			.then(() => {

			});
	}

	GetTemplate(charType: string) {
		// Clears the charTemplates and charStatuses before loading new templates
		this.charTemplate = [];
		this.charStatus = [];
		this.adminConfigService.GetCharTypeTemplate(charType, "")
			.then((result) => {
				this.charTemplate = result;
			});
	}

	GetTemplateStatus(charTemplate: string, charType: string) {
		this.charStatus = [];
		this.adminConfigService.GetTemplateStatus(charType, charTemplate)
			.then((result) => {
				this.charStatus = result;
			});
	}

	UpdateRecords(charID: string, recIDs: string, statusID: string, templateID: string) {
		if (this.$window.confirm("Are you sure you want to perform this update?")) {
			this.notifyService.startProgress();
			var statusLabel = _.find(this.charStatus, s => s.stepID == parseInt(statusID)).stepName;
			//check the entities to ensure they are valid
			this.adminConfigService.validateBulkUpdateStatusRecords(charID, templateID, recIDs).then((results) => {
				var invalidRecIDs = _.map(results.data, r => r.recID);

				if (invalidRecIDs.length == 0) {
					this.adminConfigService.bulkUpdateStatus(charID, recIDs, statusID, statusLabel, templateID).then((result) => {
						if (result) {
							this.jobId = result.jobID;
							this.jobTitle = result.jobTitle;
							this.showJobProgressStatus = true;
							this.notifyService.endProgress();
						}
						else {
							this.notifyService.notifyError("Update Unsuccessful");
							this.notifyService.endProgress();
						}
					});
				}
				else {
					var errorString = invalidRecIDs.join(","); // might need to get only the first 10 or so
					this.notifyService.notifyError(`Cannot Update Status because the following IDs do not belong to the selected template ${errorString}`);
					this.notifyService.endProgress();
				}
			});
		}
	}

	GetEntities(charID: string, divID: number, recIDs: string) {
		var promises = [];
		var splitRecIDs = recIDs.split(",");
		splitRecIDs.forEach((recID) => {
			var formattedRecID = `d${divID}c${charID}r${recID.trim()}`;
			promises.push(this.entityService.getEntity(formattedRecID));
		});
		return promises;
	}
}
